import {
  Highlight,
  Stack,
  Text,
  useColorModeValue,
  VStack,
  useBreakpointValue,
} from "@chakra-ui/react";
import GitHubCalendar from "react-github-calendar";
import Tilt from "react-parallax-tilt";

function Github() {
  const HeadingColor = useColorModeValue("black", "white");
  const QueryColor = useColorModeValue("#e53e3e", "#eac288");

  // Dynamically adjust months based on screen size
  const monthsToShow = useBreakpointValue({ base: 6, md: 12 }); // 6 months for mobile, 12 for desktop
  const blockSize = useBreakpointValue({ base: 20, md: 20 });
  const fontSize = useBreakpointValue({ base: 12, md: 16 });
  const blockMargin = useBreakpointValue({ base: 5, md: 10 });

  return (
    <VStack
      minH={{ base: "40vh", md: "50vh" }}
      justifyContent="center"
      spacing={5}
      mx="auto"
      w={{ base: "90%", md: "80%" }}
    >
      {/* Heading Section */}
      <Stack textAlign="center" data-aos="fade-up" spacing={2}>
        <Text
          color={HeadingColor}
          fontSize={{ base: "2xl", sm: "3xl", md: "4xl" }}
          fontWeight="semibold"
        >
          <Highlight query="CALENDAR" styles={{ color: QueryColor }}>
            GITHUB CONTRIBUTION CALENDAR
          </Highlight>
        </Text>
        <Text fontSize="sm" color="gray.500">
          A visual overview of my open-source contributions
        </Text>
      </Stack>

      {/* GitHub Calendar */}
      <Tilt>
        <Stack data-aos="fade-up">
          <GitHubCalendar
            username="suFi7867"
            blockSize={blockSize}
            blockRadius={5}
            blockMargin={blockMargin}
            color={QueryColor}
            fontSize={fontSize}
            transformData={(contributions) =>
              monthsToShow === 6
                ? contributions.slice(contributions.length - 150) // Approx. 6 months
                : contributions
            }
          />
        </Stack>
      </Tilt>
    </VStack>
  );
}

export default Github;
